import React, { useState, useEffect } from "react";
import {
    MenuItem,
    Grid,
    FormControl,
    InputLabel,
    Select,
    Paper,
    Typography,
    Button,
} from "@material-ui/core";
import { StyledHeader } from "../../../styles";
import Box from "@material-ui/core/Box";
import styled from "styled-components";

const InfoDiv = styled(Paper)`
    width: 100%;
    margin-right: 15px;
    border: 0.5px solid #0188cc;
    margin-top: 25px;
`;

const StyledFormControl = styled(FormControl)`
    min-width: 120px !important;
    max-width: 150px !important;
`;

const SecurityInfo = (props) => {
    const [editingProfile, setEditing] = useState(false);
    const [userProfile, setUserProfile] = useState(props.userProfile);
    const [userTypes, setUserTypes] = useState(props.userTypes);
    const { setUpdatedSecurityInfo, setSnackBarState } = props;
    useEffect(() => {
        setUserTypes(props.userTypes);
    }, [props.userTypes]);

    const renderDropDown = (label, key, userProfile, editingProfile) => {
        console.log(userTypes);
        if (editingProfile) {
            return (
                <StyledFormControl>
                    <InputLabel>User Types:</InputLabel>

                    <Select
                        value={userProfile.user_type}
                        onChange={(event) => {
                            setUserProfile({
                                ...userProfile,
                                user_type: event.target.value,
                            });
                        }}
                    >
                        {userTypes &&
                            userTypes.map((e, key) => {
                                const name = e;
                                const nameCapitalized = name.charAt(0).toUpperCase() + name.slice(1)
                                return (
                                    <MenuItem key={key} value={e}>
                                        {nameCapitalized}
                                    </MenuItem>
                                );
                            })}
                    </Select>
                    {/* <br />
                    <Button
                        disabled={props.canUpdate === false}
                        onClick={() => {
                            props.submitUpdatedProfile(userProfile);
                            setEditing(false);
                        }}
                        variant="contained"
                        color="#0188cc"
                        style={{ marginLeft: 5, marginTop: -5 }}
                    >
                        Save
                    </Button> */}
                </StyledFormControl>
            );
        } else {
            let accessLevel = {'admin' : 'Admin', 'manager' : 'Manager', 'staff' : 'Staff'};
            return renderValues(label, accessLevel[userProfile[key]]);
        }
    };

    const renderAccessLevelDropDown = (
        label,
        key,
        userProfile,
        editingProfile
    ) => {
        if (editingProfile) {
            return (
                <StyledFormControl>
                    <InputLabel>Access Level</InputLabel>
                    <Select
                        value={userProfile.access_level}
                        onChange={(event) => {
                            setUserProfile({
                                ...userProfile,
                                access_level: event.target.value,
                            });
                            setSnackBarState(false);
                        }}
                    >
                        {userProfile.uid !== props.loggedUID && (
                            <MenuItem value="Level 0">Level 0</MenuItem>
                        )}
                        <MenuItem value="Level 1">Level 1</MenuItem>
                        <MenuItem value="Level 2">Level 2</MenuItem>
                        <MenuItem value="Level 3">Level 3</MenuItem>
                        <MenuItem value="Level 4">Level 4</MenuItem>
                        <MenuItem value="Equipment">Admin - Equipment</MenuItem>
                        <MenuItem value="Plant">Admin - Plant</MenuItem>
                        <MenuItem value="User">Admin - User</MenuItem>
                        <MenuItem value="Client">Client</MenuItem>
                        <MenuItem value="Contractor">Contractor</MenuItem>
                    </Select>
                </StyledFormControl>
            );
        } else {
            
            let accessLevel = {'Level 0' : 'Level 0', 'Level 1' : 'Level 1', 'Level 2' : 'Level 2', 'Level 3' : 'Level 3',
            'Level 4' : 'Level 4', 'Equipment' : 'Admin - Equipment', 'Plant' : 'Admin - Plant', 'User' : 'Admin - User',
            'Client' : 'Client', 'Contractor' : 'Contractor' };
            return renderValues(label, accessLevel[ userProfile[key]]);
        }
    };

    const renderDropDownSecurityLevel = (
        label,
        key,
        userProfile,
        editingProfile
    ) => {
        if (editingProfile) {
            return (
                <>
                    <StyledFormControl>
                        <InputLabel>Security Level</InputLabel>
                        <Select
                            value={userProfile.security_level}
                            onChange={(event) => {
                                props.submitUpdatedProfile(userProfile);
                                setUserProfile({
                                    ...userProfile,
                                    security_level: event.target.value,
                                });
                                setSnackBarState(false);
                            }}
                        >
                            <MenuItem value="Admin">Admin</MenuItem>
                            <MenuItem value="User">User</MenuItem>
                        </Select>
                    </StyledFormControl>
                    <br />
                    <Button
                        disabled={props.canUpdate === false}
                        onClick={() => {
                            setUpdatedSecurityInfo(
                                userProfile.uid,
                                userProfile
                            );
                            setEditing(false);
                        }}
                        variant="contained"
                        style={{
                            marginTop: 10,
                            background: "#0188cc",
                            color: "white",
                            marginLeft: "55px"
                        }}
                    >
                        Save
                    </Button>
                </>
            );
        } else {
            return renderValues(label, userProfile[key]);
        }
    };

    return (
        <>
            <InfoDiv
                style={{
                    borderWidth: "0.5px",
                    borderColor: "#0188cc",
                    marginTop: "25px",
                }}
            >
                <StyledHeader
                    style={{
                        height: "fit-content",
                        width: "100%",
                        backgroundColor: "#0188cc",
                    }}
                >
                    <Box display="flex">
                        <Box flexGrow={1}>
                            <Typography
                                variant="display1"
                                style={{ color: "white" }}
                            >
                                User Type & Security
                            </Typography>
                        </Box>
                        <Box style={{ paddingRight: "15px" }}>
                            <Button
                                variant="contained"
                                size="small"
                                style={{
                                    backgroundColor: "#FFA500",
                                    color: "white",
                                    maxHeight: "25px",
                                }}
                                onClick={() => {
                                    setEditing((edit) => !edit);
                                    setUserProfile(props.userProfile);
                                }}
                            >
                                {editingProfile ? "Cancel Edit" : "Edit"}
                            </Button>
                        </Box>
                    </Box>
                </StyledHeader>
                <Grid
                    container
                    spacing={3}
                    style={{ display: "inlineBlock", margin: 12 }}
                >
                    <Grid item xs={4} style={{ paddingLeft: "30px" }}>
                        {renderDropDown(
                            "User Types:",
                            "user_type",
                            userProfile,
                            editingProfile,
                            (key, value) => {
                                setUserProfile({
                                    ...userProfile,
                                    [key]: value,
                                });
                            }
                        )}
                    </Grid>

                    <Grid item xs={4}>
                        {renderAccessLevelDropDown(
                            "Access Level:",
                            "access_level",
                            userProfile,
                            editingProfile,
                            (key, value) => {
                                setUserProfile({
                                    ...userProfile,
                                    [key]: value,
                                });
                            }
                        )}
                    </Grid>

                    <Grid item xs={4}>
                        {renderDropDownSecurityLevel(
                            "Security Level:",
                            "security_level",
                            userProfile,
                            editingProfile,
                            (key, value) => {
                                setUserProfile({
                                    ...userProfile,
                                    [key]: value,
                                });
                            }
                        )}
                    </Grid>
                </Grid>

                {/* <Grid
                    style={{ margin: 30, marginTop: 30 }}
                    spacing={4}
                    container
                >
                    
                    <Grid item xs={6} xl={6}>
                        <Button
                            disabled={props.canUpdate === false}
                            onClick={() => setModalState(true)}
                            variant="contained"
                            color="primary"
                            style={{ marginTop: 10 }}
                        >
                            Change Password
                        </Button>
                    </Grid>
                    <Grid item xs={6} xl={6}>
                        <Button
                            disabled={props.canUpdate === false}
                            onClick={() =>
                                setUpdatedSecurityInfo(
                                    userProfile.uid,
                                    userProfile
                                )
                            }
                            variant="contained"
                            color="primary"
                            style={{ marginTop: 10 }}
                        >
                            Save
                        </Button>
                    </Grid>
                </Grid> */}
            </InfoDiv>
        </>
    );
};
const renderValues = (label, value) => {
    
    return (
        <div>
            <Typography style={{ wordWrap: "break-word" }} variant="title">
                {" "}
                <b style={{ color: "#0188cc" }}>{label} </b> <br />
                {typeof value === "object"
                    ? value.map((e, i) => {
                          return (
                              <span>
                                  {e} {value[i + 1] ? ", " : ""} 
                              </span>
                          );
                      })
                    :value }
            </Typography>
        </div>
    );
};
export default SecurityInfo;
